<template>
  <div
    class="select-container"
    :class="{error: error}">
    <label :for="id">
      <slot />
      <transition name="showErrorIcon">
        <icon v-if="error" size="small" icon="error" />
      </transition>
    </label>
    <ShForm>
      <div class="select-wrapper">
        <select
          :id="id"
          :value="value"
          :name="name"
          :autocomplete="autocomplete"
          :disabled="disabled"
          @change="onChange">
            <option value="" disabled v-if="!!placeholder">{{ placeholder }}</option>
            <template v-for="item in items">
              <optgroup
                v-if="item.group"
                :key="item.group"
                :label="item.group">
                <option
                  v-for="groupItem in item.items"
                  :value="groupItem.value"
                  :key="groupItem.value"
                  >
                  {{groupItem.label}}
                </option>
              </optgroup>
              <option
                v-if="!item.group"
                :key="item.value"
                :value="item.value"
                >
                {{item.label}}
              </option>
            </template>
        </select>
        <div class="select-indicator">
          <icon icon="disclosure" size="small" />
        </div>
      </div>
    </ShForm>
    <div class="form-control-feedback">
      <slot name="feedback" />
    </div>
    <div class="form-control-info">
      <slot name="info" />
    </div>
  </div>
</template>

<script>
import { ShForm } from '@sohohouse/design-system'
import { v4 as uuid } from 'uuid'

export default {
  components: {
    ShForm
  },

  props: {
    items: {
      type: Array,
      required: false
    },
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: false
    },
    autocomplete: {
      type: String,
      required: false
    },
    error: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      id: null
    }
  },
  methods: {
    onChange (e) {
      this.$emit('input', (e.target) ? e.target.value : e)
    }
  },
  mounted () {
    this.id = `select-input-${uuid()}`
  }
}
</script>

<style lang="scss" scoped>

.form-control-feedback,
.form-control-info {
  &:empty {
    display: none;
  }
}

select {
  outline: none;
  appearance: none;
  background: none;
  & + .select-indicator .icon {
    transform: rotate(0deg);
  }

  &:active,
  &:focus {
    & + .select-indicator .icon {
      transform: rotate(180deg);
    }
  }
}
.select-wrapper {
  position: relative;
  display: flex;
  .select-indicator {
    display: flex;
    pointer-events: none;
  }
}


label {
  @include font('040');
  display: block;
  text-transform: none;
  color: $color-black;
  margin-bottom: $d-xx-small;
}

select {
  @include transition-fast;

  border: none;
  padding: $d-small;
  background: none;
  width: 100%;
  border-radius: 2px 2px 0 0;
  outline-offset: 4px;

  &:focus {
    padding-top: $d-small;
    border-color: $color_cream;
    background-color: $color_cream;
  }

  &[disabled] {
    border-color: $deprecated-grey-x-light;
    color: rgba($deprecated-grey-dark, 0.5);
    pointer-events: none;
    cursor: not-allowed;

    & + .select-indicator .icon {
      opacity: 0.5;
    }
  }
}
.select-wrapper {
  position: relative;
  display: flex;
  align-content: center;

  .select-indicator {
    position: absolute;
    right: $space-030;
    top: 0;
    bottom: 0;
    display: flex;
    align-self: center;
    align-items: center;
    padding: 0;
    @include transition-slow;
    pointer-events: none;
  }

  .icon {
    fill: $deprecated-grey-dark;
  }
}

.form-control-feedback {
  @include body-sml;
  display: none;
  padding-top: 0;
  color: $deprecated-color-ui-error;

  .error & {
    display: block;
  }
}
</style>
